import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {
  InputNumber,
  InputNumberDocGet,
  InputText,
} from '../../../../../../../../components/UI/Input'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {Select} from '../../../../../../../../components/UI/Select'
import {FormProvider, useForm} from 'react-hook-form'
import {LegalRepresentativeModel, SelectModel} from '../../../../../../model'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {getMasterService} from '../../../../../../../central/services'
import {createLegalRepresentative, updateLegalRepresentative} from '../../../../../../services'
import {ShowSnackBar} from '../../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getLegalRepresentatives: () => void
  created: boolean
  legalRepToEdit: LegalRepresentativeModel
}

const ModalAddLegalRepresentative: FC<Props> = ({
  show,
  setShow,
  created,
  legalRepToEdit,
  getLegalRepresentatives,
}) => {
  const {currentTabItem} = useLavanderia()
  const [maxLength, setMaxLength] = useState(0)
  const [cargo, setCargo] = useState<SelectModel[]>([])
  const [sex, setSex] = useState<SelectModel[]>([])
  const [docType, setDocType] = useState<SelectModel[]>([])

  const handleClose = () => {
    setShow(false)
    resetForm()
  }

  const legalRepresentativeSchema = Yup.object().shape({
    nombres: Yup.string().required('Nombres es obligatorio'),
    apellidoPaterno: Yup.string().required('Apellido paterno es obligatorio'),
    apellidoMaterno: Yup.string().required('Apellido materno es obligatorio'),
    esInterlocutor: Yup.string().required('Interlocutor es obligatorio'),
    email: Yup.string().required('Email es obligatorio'),
    celular: Yup.string().required('Celular es obligatorio'),
    numeroDocumento: Yup.string().required('Numero de Documento es obligatorio'),
  })

  const methods = useForm<LegalRepresentativeModel>({
    resolver: yupResolver(legalRepresentativeSchema),
    defaultValues: {
      esInterlocutor: true,
    },
  })

  const {
    register,
    setValue,
    handleSubmit,
    setError,
    control,
    formState: {errors},
  } = methods
  const valueInterlocutor = [
    {
      value: true,
      label: 'Si',
    },
    {
      value: false,
      label: 'No',
    },
  ]

  const handleGetMaxLength = (val: any) => {
    const value = val ? val : ''
    setMaxLength(value.length)
    setValue('tipoDocumento', value.value)
    setError('tipoDocumento', {})
    setValue(`numeroDocumento`, '')
    setError('numeroDocumento', {})
  }

  const getSexList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'Sexo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      const filterData = mappedMaster.filter((item) => item.codigo !== '3')

      setSex(filterData)
    } catch (error) {
      console.error('Error al obtener la lista de sexo:', error)
    }
  }

  const getCargoList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'CargoProveedorLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setCargo(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  const getDocTypeList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const filterData = data.filter(
        (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
      )
      const mappedMaster = filterData.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        length: master.campoadicionaltxt1,
      }))
      setDocType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getDocTypeList()
    getSexList()
    getCargoList()
    setValue('proveedorId', currentTabItem.idToEdit as any)
  }, [])

  let isDisabled = false

  const onSubmit = async (data: LegalRepresentativeModel) => {
    try {
      const {data: res} = created
        ? await createLegalRepresentative(data)
        : await updateLegalRepresentative(data)
      // const {data: res} = await createLegalRepresentative(data)
      if (!res.error) {
        ShowSnackBar(`Se ${created ? 'creó' : 'actualizó'} con exito`)
        handleClose()
        getLegalRepresentatives()
        // mostrar snackbar
      } else {
        ShowSnackBar(res.message || 'Hubo un error', 'error')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  const resetForm = () => {
    setValue('nombres', '')
    setValue('apellidoPaterno', '')
    setValue('apellidoMaterno', '')
    setValue('telefono', '')
    setValue('celular', '')
    setValue('email', '')
    setValue('tipoDocumento', '')
    setValue('numeroDocumento', '')
    setValue('sexo', '')
    setValue('cargo', '')
    setValue('esInterlocutor', true)
  }

  useEffect(() => {
    if (!created) {
      setValue('id', legalRepToEdit?.id)
      setValue('nombres', legalRepToEdit?.nombres)
      setValue('apellidoPaterno', legalRepToEdit?.apellidoPaterno)
      setValue('apellidoMaterno', legalRepToEdit?.apellidoMaterno)
      setValue('telefono', legalRepToEdit?.telefono)
      setValue('celular', legalRepToEdit?.celular)
      setValue('email', legalRepToEdit?.email)
      setValue('tipoDocumento', legalRepToEdit?.tipoDocumento)
      setValue('numeroDocumento', legalRepToEdit?.numeroDocumento)
      setValue('sexo', legalRepToEdit?.sexo)
      setValue('cargo', legalRepToEdit?.cargo)
      setValue('esInterlocutor', legalRepToEdit?.esInterlocutor)
      setValue('estado', 'ACT')
    }
  }, [created])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{created ? 'Crear' : 'Editar'} Representante Legal</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='d-flex align-items-center'>
                  {/* <HeaderTitle isEdit={false} title={TITLE_FORM_LEGAL_REPRESENTATIVE}/> */}
                </div>
                <div className='row mt-2'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Nombre del gerente:</label>
                    <InputText
                      name={`nombres`}
                      textPlaceholder='Escribe nombres'
                      register={register}
                      errors={errors}
                      disabled={isDisabled}
                      Uppercase={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Apellido Paterno del gerente:</label>
                    <InputText
                      name={`apellidoPaterno`}
                      textPlaceholder='Escribe el apellido paterno'
                      register={register}
                      errors={errors}
                      disabled={isDisabled}
                      Uppercase={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Apellidos Materno del gerente:</label>
                    <InputText
                      name={`apellidoMaterno`}
                      textPlaceholder='Escribe el apellido materno'
                      register={register}
                      errors={errors}
                      disabled={isDisabled}
                      Uppercase={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Número de teléfono:</label>
                    <InputNumber
                      name={`telefono`}
                      textPlaceholder='Escribe el teléfono'
                      register={register}
                      errors={errors}
                      caracteresTel={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Número de celular:</label>
                    <InputNumber
                      name={`celular`}
                      textPlaceholder='Escribe el celular'
                      register={register}
                      errors={errors}
                      caracteresTel={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Correo electrónico:</label>
                    <InputText
                      name={`email`}
                      textPlaceholder='Escribe el correo'
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Tipo de Doc. Id.:</label>
                    <Select
                      control={control}
                      name={`tipoDocumento`}
                      data={docType}
                      errors={errors}
                      onChangeValue={(e: any) => handleGetMaxLength(e)}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Número de Doc. Id.:</label>
                    <InputNumberDocGet
                      name={`numeroDocumento`}
                      textPlaceholder='Escribe el nro de documento'
                      register={register}
                      maxLength={maxLength}
                      errors={errors}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Sexo:</label>
                    <Select control={control} name={`sexo`} data={sex} errors={errors} />
                  </div>

                  <div className='col-sm-12 col-lg-3'>
                    <label className=''>Cargo:</label>
                    <Select control={control} name={`cargo`} data={cargo} errors={errors} />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Interlocutor:</label>
                    <Select
                      control={control}
                      name={`esInterlocutor`}
                      data={valueInterlocutor}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <div className='d-flex justify-content-center mb-3 mt-5'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddLegalRepresentative}
